// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1K0yU","bigColWidth":"Table_bigColWidth__3s4_D","biggerColWidth":"Table_biggerColWidth__2g7g6","row":"Table_row__n-56N","col":"Table_col__2Oh1n"};